import './map.css';
import TrailMap from './TrailMap';
import zini from '../../assets/neutral.png';

function ArrowLeftIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M19 12H5M11 6l-6 6 6 6" stroke="#3d2f7a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// x/y are percentage positions on the map.png background, lined up with
// its own waypoint rings so the path reads top-to-bottom: cafe (Discover)
// -> bench (Selfie) -> phone (Post) -> chest (Reward).
const STEPS = [
  { n: 1, color: '#6c4ce8', x: 36, y: 18 },
  { n: 2, color: '#ff9f2e', x: 60, y: 40 },
  { n: 3, color: '#ff3d81', x: 36, y: 60 },
  { n: 4, color: '#17b8a6', x: 62, y: 76 },
];

export default function MissionMap({ onBack, currentStep = 1, onSelectStep }) {
  const nodes = STEPS.map((step) => {
    const isDone = step.n < currentStep;
    const isActive = step.n === currentStep;
    const isLocked = step.n > currentStep;

    return {
      id: step.n,
      state: isDone ? 'done' : isActive ? 'active' : 'locked',
      disabled: isLocked,
      color: step.color,
      x: step.x,
      y: step.y,
      ariaLabel: `Step ${step.n}`,
      onClick: () => onSelectStep?.(step.n),
    };
  });

  return (
    <div className="map-screen">
      <div className="map-frame">
        <div className="map-topbar">
          <button type="button" className="map-back-btn" aria-label="Go back" onClick={onBack}>
            <ArrowLeftIcon />
          </button>
          <div className="map-topbar-text">
            <span className="map-title">Mission Map</span>
            <span className="map-subtitle">Step {currentStep} of {STEPS.length}</span>
          </div>
          <div className="map-back-btn-spacer" />
        </div>

        <TrailMap nodes={nodes} activeId={currentStep} avatarSrc={zini} />
      </div>
    </div>
  );
}
